<template>
  <section class="small-basket-control">
    <div class="small-basket-control__icon" @click="changeOpenSmallBasket(!isOpenSmallBasket)">
      <svg><use xlink:href="#svg-basket"></use></svg>
      <span v-if="items" class="small-basket-control__count">{{ items.length }}</span>
    </div>
    <BasketWrapper />
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import BasketWrapper from '@components/Basket/BasketWrapper.vue';

export default {
  name: 'SmallBasket',
  components: { BasketWrapper },
  computed: {
    ...mapState({
      isOpenSmallBasket: ({ basket }) => basket.data.isOpenSmallBasket,
      items: ({ basket }) => basket.data.items,
    }),
  },
  methods: {
    ...mapMutations({
      changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
    }),
  },
};
</script>

<style lang="scss" scoped>
.small-basket-control {
  &__icon {
    display: flex;
    align-items: flex-end;
    cursor: pointer;
    svg {
      display: block;
      width: 24px;
      height: 24px;
      fill: var(--background-black);
      transition: 0.2s linear fill;
      margin-left: -3px;
    }
    &:hover {
      svg {
        fill: var(--border-colour-primary);
      }
      .small-basket-control__count {
        color: var(--color-link-hover-dark);
      }
    }
  }
  &__count {
    font-weight: 500;
    font-size: rem(16);
    margin-left: 4px;
    transition: 0.2s linear color;
  }
}
</style>
